import { observer } from 'mobx-react-lite'
import { StaffingDetailsPanel } from '@/features/admin/staffing/components/StaffingDetailsPanel'
import { type StaffingDetailsViewModel } from './StaffingDetailsViewModel'

export interface StaffingDetailsPanelContainerProps {
  vm: StaffingDetailsViewModel
}

export const StaffingDetailsPanelContainer = observer(
  function StaffingDetailsPanelContainer({
    vm,
  }: StaffingDetailsPanelContainerProps) {
    if (!vm.modal.showing) {
      return null
    }

    return (
      <StaffingDetailsPanel
        onClose={vm.modal.close}
        posting={vm.postingDetails}
        applicantsExpanded={vm.applicantsExpanded}
        onToggleApplicantsExpanded={vm.toggleApplicantsExpanded}
        showManageButton={vm.showManageButton}
        onManage={vm.applicantManagementPanelVm.modal.show}
        showActions={vm.showActions}
        showDraftActions={vm.isInDraft}
        showMarkInReview={vm.showMarkInReview}
        showInReviewActions={vm.showInReviewActions}
        onUpdateDraft={vm.updateDraft}
        onPublish={vm.publish}
        isPublishPending={vm.publish.pending}
        onMarkInReview={vm.markInReview}
        isMarkInReviewPending={vm.markInReview.pending}
        onReactivate={vm.reactivate}
        isReactivatePending={vm.reactivate.pending}
        onManuallyClose={vm.manuallyClose}
        isManuallyClosePending={vm.manuallyClose.pending}
      />
    )
  },
)
